import { formatTimestampWithTimezone, getValidTimezone } from '../../../../utils/formatTimestamp';

export function getStringValue(record: Record<string, unknown>, key: string) {
  const value = record[key];
  return typeof value === 'string' && value.trim() ? value : undefined;
}

export function getNumberValue(record: Record<string, unknown>, key: string) {
  const value = record[key];
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

export function formatSearchCurrency(amount: number | undefined) {
  if (amount === undefined) {
    return null;
  }

  return new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
  }).format(amount);
}

export function formatSearchDate(timestamp: string | undefined) {
  if (!timestamp) {
    return null;
  }

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatSearchDateInTimezone(
  timestamp: string | undefined,
  dashboardTimezone?: string | null,
) {
  if (!timestamp) {
    return null;
  }

  const formatted = formatTimestampWithTimezone(
    timestamp,
    dashboardTimezone ? getValidTimezone(dashboardTimezone, 'America/Chicago') : 'America/Chicago',
    'MMM D, YYYY',
  );

  return formatted || formatSearchDate(timestamp);
}

export function formatCustomerFacingFormType(type: string | undefined) {
  if (type === 'EVENT') {
    return 'Event';
  }

  return 'Fundraising';
}
